<div class="container" [style.height]="initHeight" #dialog
    [style.left.px]="position.x / zoom.getZoomValue" [style.top.px]="position.y / zoom.getZoomValue"
    [class.lock-bot]="(((card.offsetHeight + position.y + 10) / zoom.getZoomValue) > (screenH / zoom.getZoomValue)) || lockBot" [class.lock-right]="((card.offsetWidth + position.x + 10) / zoom.getZoomValue) > (screenW / zoom.getZoomValue)"
    >
    <!-- [class.lock-bot]="position.lockBot" [class.lock-right]="position.lockRight" -->
    <div class="card" #card>
        <ng-container [ngTemplateOutlet]="template"></ng-container>
    </div>
</div>